import { downgradeInjectable } from '@angular/upgrade/static';
import { FeatureFlagsFacade } from '@mode/shared/contract-common';
import { LaunchDarklyFlagsDataService } from '@mode/shared/util-feature-flags';
import * as angular from 'angular';

const launchDarklyKey = angular.element('meta[name=launch-darkly-client-id]').attr('content');
const launchDarklyEnv = angular.element('meta[name=launch-darkly-env]').attr('content');

export const DowngradedSharedUtilFeatureFlagsModule = angular
  .module('downgraded-shared-util-feature-flags', [])
  .constant('LaunchDarklyConfig', {
    sdkKey: launchDarklyKey,
    envKey: launchDarklyEnv,
  })
  .service('FeatureFlagsFacade', downgradeInjectable(FeatureFlagsFacade))
  .service('LaunchDarklyFlagsDataService', downgradeInjectable(LaunchDarklyFlagsDataService)).name;
